import {
    Dashboard,
    Data,
    DetailData,
    LihatDetailData,
    Organisasi,
    DetailOrganisasi,
    InfoGrafis,
    DetailInfoGrafis,
    Kategori,
    DetailKategori,
    Tentang,
    KritikSaran,
    Tag,
    DetailTag,
    File,
    DetailFile,
    Home
} from "./views";

const routes = [
    { path: "/", exact: true, name: "Home", Component: Home },
    { path: "/dashboard", exact: true, name: "Home", Component: Dashboard },
    { path: "/data", exact: true, name: "Data", Component: Data },
    { path: "/data/detail/:iddetail", exact: true, name: "Detail Data", Component: DetailData },
    { path: "/data/detail/:iddetail/lihat/:idlihat", exact: true, name: "Lihat Data dan Sumber Data", Component: LihatDetailData },
    { path: "/organisasi", exact: true, name: "Organisasi", Component: Organisasi },
    { path: "/organisasi/detail/:iddetail", exact: true, name: "Detail Organisasi", Component: DetailOrganisasi },
    { path: "/kategori", exact: true, name: "Kategori", Component: Kategori },
    { path: "/kategori/detail/:iddetail", exact: true, name: "Detail Kategori", Component: DetailKategori },
    { path: "/info-grafis", exact: true, name: "Info Grafis", Component: InfoGrafis },
    { path: "/info-grafis/detail/:iddetail", exact: true, name: "Detail Info Grafis", Component: DetailInfoGrafis },
    { path: "/tentang", exact: true, name: "Tentang", Component: Tentang },
    { path: "/kritik-saran", exact: true, name: "Kritik & Saran", Component: KritikSaran },
    { path: "/tag", exact: true, name: "Tag", Component: Tag },
    { path: "/tag/detail/:iddetail", exact: true, name: "Detail Tag", Component: DetailTag },
    { path: "/file", exact: true, name: "File", Component: File },
    { path: "/file/detail/:iddetail", exact: true, name: "Detail File", Component: DetailFile },
]

export default routes;